import { Component, OnInit } from '@angular/core';
import { UserStateService } from 'src/app/services/user-state.service';

@Component({
  selector: 'app-emplay-consultant',
  template: `
    <div class="home-page">
      <div class="greet">
        <h1>Welcome back, {{ firstName }} 👋</h1>
        <p>Manage and run your solutions.</p>
      </div>

      <app-my-solutions></app-my-solutions>
    </div>
  `,
  styleUrls: ['./emplay-consultant.component.scss'],
})
export class EmplayConsultantComponent implements OnInit {
  firstName: string = 'there';

  constructor(private userState: UserStateService) {}

  ngOnInit(): void {
    const info: any = this.userState.getCurrentUserInfo();
    this.firstName =
      info?.first_name ||
      (info?.username || info?.email || 'there').split('@')[0];
  }

  modules = [
    {
      key: 'data_management',
      cardName: 'Data Management',
      cardDesc:
        'Configure, Manage, and Expand Data Sources. Easily set up, control, and add database connections',
      buttonName: [
        {
          btnName: 'Data Manager',
          btnRoute: '../data_management/data_sources/default',
        },
        {
          btnName: 'Connection Manager',
          btnRoute: '../data_connection/',
        },
      ],
    },
    {
      cardName: 'Sales AI Solutions',
      cardDesc:
        'Transform Your Sales Strategy with Cutting-Edge AI Solutions: Sales DNA/Coaching, Impact/Ramp Analysis, etc!',
      buttonName: [
        { btnName: 'Create', btnRoute: '../manage-solutions/configureProject' },
        { btnName: 'Manage', btnRoute: '../manage-solutions/configureProject' },
      ],
    },
  ];

  title: string = 'Home';
}
